import "./LoginForm.html";
import "./LoginForm.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { LoginFormComponentController } from "./LoginFormComponentController";

export class LoginFormComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            aboutReference: "<",
            stateAfterLogin: "<",
        };
        this.controller = LoginFormComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/LoginForm/LoginForm.html";
    }
}
